import { useMemo, useState } from "react"
import Dashboard from "../../components/Dashboard"
import TableSearch, { filterRows } from "../../components/Custom/TableSearch"
import RegistroTable from "../../components/Registro"
import useFetchParticipantes from "../../hooks/useFetchParticipantes"
import useExcelExportRegistro from "../../components/Registro/useExcelExportRegistro"
import UIButton from "../../components/UI/UIButton"

const RegistroPage = () => {

    const { participantes, loading } = useFetchParticipantes()
    const { exportToExcel } = useExcelExportRegistro(participantes)
    const [filtroBusqueda, setFiltroBusqueda] = useState('')

    const participantesFiltrados = useMemo(
        () => filterRows(participantes, filtroBusqueda, ['codigoRegistro', 'nombreProfesor', 'email', 'ciudad', 'puesto', 'nivelEducativo']),
        [filtroBusqueda, participantes]
    )

    const total = participantes.length
    const confirmados = participantes.filter(p => p.fechaAsistencia).length

    return (
        <Dashboard>
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0% 0' }}>
                <h1>REGISTRO DE PARTICIPANTES</h1>
                <UIButton onClick={exportToExcel} text='Descargar Excel' />
            </div>
            {!loading && (
                <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                    <div style={{ padding: '0.75rem 1.25rem', background: '#f0f0f0', borderRadius: '8px' }}>
                        <span style={{ fontSize: '0.75rem', color: '#666', display: 'block' }}>Registrados</span>
                        <strong style={{ fontSize: '1.5rem' }}>{total}</strong>
                    </div>
                    <div style={{ padding: '0.75rem 1.25rem', background: '#e8f5e9', borderRadius: '8px' }}>
                        <span style={{ fontSize: '0.75rem', color: '#666', display: 'block' }}>Confirmaron asistencia</span>
                        <strong style={{ fontSize: '1.5rem', color: '#2e7d32' }}>{confirmados}</strong>
                    </div>
                </div>
            )}
            <TableSearch
                value={filtroBusqueda}
                onChange={setFiltroBusqueda}
                label="Buscar participante"
                placeholder="Código, nombre, email, ciudad, puesto..."
            />
            {loading ? <p>Cargando...</p> : <RegistroTable participantes={participantesFiltrados} />}
        </Dashboard>
    )
}

export default RegistroPage
